import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["className", "clsPrefix", "style", "itemWidth", "status", "iconPrefix", "icon", "wrapperStyle", "adjustMarginRight", "stepNumber", "description", "title", "progressDot", "tailContent", "icons"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
* This source code is quoted from rc-steps.
* homepage: https://github.com/react-component/steps
*/
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function isString(str) {
  return typeof str === 'string';
}

var Step = /*#__PURE__*/function (_React$Component) {
  _inherits(Step, _React$Component);

  var _super = _createSuper(Step);

  function Step() {
    _classCallCheck(this, Step);

    return _super.apply(this, arguments);
  }

  _createClass(Step, [{
    key: "renderIconNode",
    value: function renderIconNode() {
      var _classNames;

      var _this$props = this.props,
          clsPrefix = _this$props.clsPrefix,
          progressDot = _this$props.progressDot,
          stepNumber = _this$props.stepNumber,
          status = _this$props.status,
          title = _this$props.title,
          description = _this$props.description,
          icon = _this$props.icon,
          iconPrefix = _this$props.iconPrefix,
          icons = _this$props.icons;
      var iconNode;
      var iconClassName = classNames("".concat(clsPrefix, "-icon"), "".concat(iconPrefix, "icon"), (_classNames = {}, _defineProperty(_classNames, "".concat(iconPrefix, "icon-").concat(icon), icon && isString(icon)), _defineProperty(_classNames, "".concat(iconPrefix, "icon-check"), !icon && status === 'finish' && icons && !icons.finish), _defineProperty(_classNames, "".concat(iconPrefix, "icon-close"), !icon && status === 'error' && icons && !icons.error), _classNames));
      var iconDot = /*#__PURE__*/React.createElement("span", {
        className: "".concat(clsPrefix, "-icon-dot")
      }); // `progressDot` enjoy the highest priority

      if (progressDot) {
        if (typeof progressDot === 'function') {
          iconNode = /*#__PURE__*/React.createElement("span", {
            className: "".concat(clsPrefix, "-icon")
          }, progressDot(iconDot, {
            index: stepNumber - 1,
            status: status,
            title: title,
            description: description
          }));
        } else {
          iconNode = /*#__PURE__*/React.createElement("span", {
            className: "".concat(clsPrefix, "-icon")
          }, iconDot);
        }
      } else if (icon && !isString(icon)) {
        iconNode = /*#__PURE__*/React.createElement("span", {
          className: "".concat(clsPrefix, "-icon")
        }, icon);
      } else if (icons && icons.finish && status === 'finish') {
        iconNode = /*#__PURE__*/React.createElement("span", {
          className: "".concat(clsPrefix, "-icon")
        }, icons.finish);
      } else if (icons && icons.error && status === 'error') {
        iconNode = /*#__PURE__*/React.createElement("span", {
          className: "".concat(clsPrefix, "-icon")
        }, icons.error);
      } else if (icon || status === 'finish' || status === 'error' || status === 'process' || status === 'wait') {
        iconNode = /*#__PURE__*/React.createElement("span", {
          className: iconClassName
        });
      } else {
        iconNode = /*#__PURE__*/React.createElement("span", {
          className: "".concat(clsPrefix, "-icon")
        }, stepNumber);
      }

      return iconNode;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          clsPrefix = _this$props2.clsPrefix,
          style = _this$props2.style,
          itemWidth = _this$props2.itemWidth,
          _this$props2$status = _this$props2.status,
          status = _this$props2$status === void 0 ? 'wait' : _this$props2$status,
          iconPrefix = _this$props2.iconPrefix,
          icon = _this$props2.icon,
          wrapperStyle = _this$props2.wrapperStyle,
          adjustMarginRight = _this$props2.adjustMarginRight,
          stepNumber = _this$props2.stepNumber,
          description = _this$props2.description,
          title = _this$props2.title,
          progressDot = _this$props2.progressDot,
          tailContent = _this$props2.tailContent,
          icons = _this$props2.icons,
          restProps = _objectWithoutProperties(_this$props2, _excluded);

      var classString = classNames("".concat(clsPrefix, "-item"), "".concat(clsPrefix, "-item-").concat(status), className, _defineProperty({}, "".concat(clsPrefix, "-item-custom"), icon));

      var stepItemStyle = _objectSpread({}, style);

      if (itemWidth) {
        stepItemStyle.width = itemWidth;
      }

      if (adjustMarginRight) {
        stepItemStyle.marginRight = adjustMarginRight;
      }

      return /*#__PURE__*/React.createElement("div", _extends({}, restProps, {
        className: classString,
        style: stepItemStyle
      }), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-item-tail")
      }, tailContent), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-item-icon")
      }, this.renderIconNode()), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-item-content")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-item-title")
      }, title), description && /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-item-description")
      }, description)));
    }
  }]);

  return Step;
}(React.Component);

Step.propTypes = {
  className: PropTypes.string,
  clsPrefix: PropTypes.string,
  style: PropTypes.object,
  wrapperStyle: PropTypes.object,
  itemWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  status: PropTypes.string,
  iconPrefix: PropTypes.string,
  icon: PropTypes.node,
  adjustMarginRight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  stepNumber: PropTypes.string,
  description: PropTypes.any,
  title: PropTypes.any,
  progressDot: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  tailContent: PropTypes.any,
  icons: PropTypes.shape({
    finish: PropTypes.node,
    error: PropTypes.node
  })
};
export default Step;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-steps/src/Step.js